import type { IChecklist } from '~/types'
import {
  Cursive,
  CurveBanner,
  Header,
  Title,
  Wrapper,
  HeroText,
  BackgroundWrap,
  CheckList,
  GradientWrap
} from '~/ui'

import { CursiveBasic } from '../../../ui/cursive-basic'

const HeadContentCheckListData: IChecklist[] = [
  {
    id: '1',
    title: '100% natural ingredients'
  },
  {
    id: '2',
    title: 'No fillers, preservatives or additives'
  },
  {
    id: '3',
    title: 'Rich in vital nutrients '
  },
  {
    id: '4',
    title: 'Reduces need for supplements'
  },
  {
    id: '5',
    title: 'Recommended by vets and pet nutritionists'
  },
  {
    id: '6',
    title: 'Locally sourced, farm fresh'
  },
  {
    id: '7',
    title: 'Premium quality at affordable prices'
  }
]

export const HeadContent = () => (
  <BackgroundWrap className="h-full w-full md:bg-meat">
    <GradientWrap className="bg-colorEight md:bg-transparent md:from-colorEight md:via-colorEight md:to-transparent">
      <CurveBanner>
        {/* <Header className="text-colorFourteen">Our Difference</Header> */}
        <div className="container mx-auto p-0 px-6">
          <h1 className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
            Our Difference
          </h1>
        </div>
      </CurveBanner>
      <div className="relative">
        <div className="container mx-auto px-6 pt-20 pb-0">
          <div className="">
            <div className="absolute top-0 left-0 block h-full w-full bg-meat bg-cover md:hidden" />
            <div className="absolute top-0 left-0 block h-full w-full bg-gradient-to-t from-colorEight to-transparent md:hidden" />
            <div className="relative">
              <div className="h-[200px]" />
              <Title className="text-colorFifteen">The Tucker Tub Difference</Title>
              <CursiveBasic>100% real ingredients, no fillers</CursiveBasic>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 pt-0">
        <div className="w-[100%] lg:w-[90%]">
          <div className="py-[30px] text-colorFifteen">
            <HeroText>
              Big brand pet food manufacturers often use fillers that can be harmful for your dog's
              digestive system. We've been using only the best natural ingredients to make
              nutritious, healthy dog food since 1996. We learnt exactly what dogs need and what
              they love.
            </HeroText>
          </div>
          <div className="space-y-3.5">
            {HeadContentCheckListData.map(item => (
              <CheckList key={item.id} title={item.title} />
            ))}
          </div>
        </div>
      </div>
    </GradientWrap>
  </BackgroundWrap>
)
